import { render, staticRenderFns } from "./diyDialog.vue?vue&type=template&id=8f7dad1e&scoped=true"
import script from "./diyDialog.vue?vue&type=script&lang=js"
export * from "./diyDialog.vue?vue&type=script&lang=js"
import style0 from "./diyDialog.vue?vue&type=style&index=0&id=8f7dad1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7dad1e",
  null
  
)

export default component.exports